import React, { useEffect, useRef, useState } from "react";
import image from "../../assets/image/Certficate.jpg";
import jsPDF from "jspdf";
import { baseUrl } from "../../shared/baseUrl";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";

const Certificate = () => {
	const [data, setData] = useState<any>({});
	const [loading, setLoading] = useState(true); // Add loading state
	const [errorMessage, setErrorMessage] = useState<string>(""); // Add error state
	const { id } = useParams<{ id: string }>();
	const reportTemplateRef = useRef(null);
	const location = useLocation();

	const currentURL = `${window.location.origin}${location.pathname}${location.search}`;

	useEffect(() => {
		const fetchData = async () => {
			try {
				const { data } = await axios.get(
					`${baseUrl}/api/v1/application/${id}/training`,
					{
						headers: {
							"Content-Type": "application/json",
						},
					}
				);
				setData(data); // Set data if request is successful
			} catch (error: any) {
				// Check for the specific error message
				if (
					error.response?.data?.errors?.[0]?.message ===
					"The applicant has not completed training."
				) {
					setErrorMessage("The applicant has not completed training.");
				} else {
					swal({
						title: "Error",
						text: error.response?.data?.message || "Something went wrong",
						icon: "error",
					});
				}
			} finally {
				setLoading(false); // Stop loading once the request completes
			}
		};

		fetchData();
	}, [id]);

	const handleGeneratePdf = () => {
		const doc = new jsPDF({
			orientation: "landscape",
			format: "a4",
			unit: "px",
		});

		doc.setFont("Arial");

		if (reportTemplateRef.current) {
			doc.html(reportTemplateRef.current, {
				callback: function (doc) {
					doc.save("certificate.pdf");
				},
				y: 7,
			});
		} else {
			doc.save("certificate.pdf");
		}
	};

	// Show loading message if data is being fetched
	if (loading) {
		return <div className="loading">Loading...</div>;
	}

	// Show error message if the applicant has not completed training
	if (errorMessage) {
		return (
			<div className="error-message">
				<p>{errorMessage}</p>
			</div>
		);
	}

	return (
		<div className="certificate-div">
			<div
				ref={reportTemplateRef}
				className="certificate"
				style={{ fontFamily: "Arial, sans-serif" }}
			>
				<div className="certificate-sub-div1">
					<p className="certificate-name font-bold text-[22px]">
						{data?.data?.firstName
							? data.data.firstName.charAt(0).toUpperCase() +
							data.data.firstName.slice(1).toLowerCase()
							: ""}
						{` `}
						{data?.data?.LastName
							? data.data.LastName.charAt(0).toUpperCase() +
							data.data.LastName.slice(1).toLowerCase()
							: ""}
					</p>

					<p className="certificate-text">has successfully completed</p>
					<p className="certificate-on">
						Customer Service Professional Certification
					</p>
					<p className="certificate-text">
						A customer service certification that offers a real-world
						environment to hone your skills.
					</p>
					<p className="certificate-text">
						Date of completion:{" "}
						{moment.utc(data?.data?.Training?.endDate).format("MMMM Do, YYYY")}
					</p>
				</div>
				<div className="certificate-sub-div2">
					{/* <p>Verified at:</p>
					<a href="/" className="certificate-link">
						{currentURL}
					</a> */}
					<p>Outcess has confirmed the identity of this individual and has</p>
					<p>participated in the course.</p>
				</div>
				<img className="certificate-image" src={image} alt="certificate" />
			</div>
			<div className="certificate_container">
				<button className="certificate-button" onClick={handleGeneratePdf}>
					Download Certificate
				</button>
			</div>
		</div>
	);
};

export default Certificate;
